/**
 * @file JS - Adapter - LayerControllerAdapter.js
 * @author : Adam Lemire
 * @since 2019/09/12
 * @version 1.0
 * @summary Dernières modifications : 2022/05/26
 */

import VectorLayer from '../classes/Layer/VectorLayer.js';
import VectorLayerController from '../controllers/Layer/VectorLayerController.js';
import RasterLayer from '../classes/Layer/RasterLayer.js';
import RasterLayerController from '../controllers/Layer/RasterLayerController.js';

/** Adaptateur pour toutes les layers du SingleMapPageController */
export default class LayerControllerAdapter {
  constructor () {
    this._states = [new VectorLayerController(), new RasterLayerController()];
    /** @type { VectorLayerController | RasterLayerController } */
    this._currentController = this._states[0];
  }

  get layer () { return this._currentController.layer; }

  set layer (layer) {
    if (layer instanceof VectorLayer || layer instanceof RasterLayer) {
      this._currentController = layer instanceof VectorLayer ? this._states[0] : this._states[1];
      this._currentController.layer = layer;
    }
  }

  updateLayerPropertiesView () {
    this._currentController.updateLayerPropertiesView();
  }

  actualiserLégende () {
    this._currentController instanceof VectorLayerController
      ? VectorLayerController.créerSymboleLégende(this._currentController.layer)
      : RasterLayerController.créerSymboleLégende(this._currentController.layer);
  }

  /** @param { VectorLayer | RasterLayer } layer */
  écouterCheckboxAfficherLayer (layer) {
    this._currentController.écouterCheckboxAfficherLayer(layer);
  }

  registerShowLayerListener (listener) {
    this._currentController.registerShowLayerListener(listener);
  }

  écouterAffichageLibelléModifié (listener) {
    if (this._currentController.layer instanceof VectorLayer) this._currentController.écouterAffichageLibelléModifié(listener);
  }

  écouterLayerSelectionnée (listener) {
    this._currentController.écouterLayerSelectionnée(listener);
  }

  écouterNomLayerModifié (listener) {
    this._currentController.écouterNomLayerModifié(listener);
  }
}
